export const STATUS_PICPAY = {
  paid: "PAGO",
  created: "AGUARDANDO PAGAMENTO",
  expired: "PRAZO PARA PAGAMENTO EXPIRADO",
  analysis: "PAGO E EM PROCESSO DE ANÁLISE ANTI-FRAUDE",
  completed: "PAGO E SALDO DISPONÍVEL",
  refunded: "PAGO E DEVOLVIDO",
  chargeback: "PAGO E COM CHARGEBACK",
};
